import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Bugsnag from '@bugsnag/expo';

/** STATE OBJECT */
const initialState = {
  loading_msg: 'idle',
  results_msg: '',
  logEveryThing: false,
  modules: [],
  logPoints: [],
};

export const fetchLoggingJson = createAsyncThunk(
  'cbcLogging/fetchLoggingJson',
  async (_, { rejectWithValue }) => {
    Bugsnag.leaveBreadcrumb('Action fetchLoggingJson dispatched');
    const response = await fetch('https://cerebrocoreusa.com/app-components/cbcLogging.json');
    
    if (!response.ok) {
      Bugsnag.notify('Api Error, fetchLoggingJson: ' + response.text());
      return rejectWithValue(response.text());
    }

    const data = await response.json();
    return data.modulesToLog;
  }
);

/** DEFINE REDUCERS */
export const cbcLoggingSlice = createSlice({
  name: 'cbcLogging',
  initialState,
  reducers: {
    PivotLogging(state, {payload}){
      if(state.modules.includes(payload.moduleName) ||  state.logEveryThing == true){
          ////console.log(payload.moduleName , ' : ' , payload.consoleLog);
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoggingJson.pending, (state) => {
        state.loading_msg = 'pending';
        state.results_msg = 'Fetching logging configuration';
      })
      .addCase(fetchLoggingJson.fulfilled, (state, { payload }) => {
        state.loading_msg = 'idle';
        state.results_msg = 'Successfully fetched logging configuration.';
        state.logEveryThing = payload.logEveryThing;
        state.modules = payload.modules;
        state.logPoints = payload.logPoints;
      })
      .addCase(fetchLoggingJson.rejected, (state, { payload }) => {
        state.loading_msg = 'failed';
        state.results_msg = payload;
      });
  },
});

// extract the reducer from the slice
const { reducer, actions } = cbcLoggingSlice;
export const { PivotLogging } = actions;


// export the reducer
export default reducer;